import {
  AlignmentType,
  BorderStyle,
  Document,
  Header as DocXHeader,
  HeightRule,
  ImageRun,
  PageOrientation,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  VerticalAlign,
  WidthType,
} from "docx";
import { logoBase64 } from "../../../../info-technology-process/repair-tools/base64";
import { breakLine, text } from "./common";

const getApprover = (steps: any[]) => {
  if (!steps.length) return "";

  const lastStep = steps[steps.length - 1];

  if (!lastStep.length) return "";

  const approver = lastStep.find((approver: any) => approver.isApproved) || lastStep[0];

  const approverName = approver.name;

  return approverName;
};

const getExportTicketForm = (item: any, isViags: boolean) => {
  const imageData = logoBase64;
  const idHead = item[0].ITHead;
  const date = new Date();

  const approverName = getApprover(item[0].eSteps);

  return new Document({
    sections: [
      {
        headers: {
          default: new DocXHeader({
            children: [
              new Paragraph({
                children: [
                  new ImageRun({
                    data: imageData,
                    transformation: {
                      width: 120,
                      height: 40,
                    },
                  }),
                ],
              }),
            ],
          }),
        },
        properties: {
          page: {
            size: {
              orientation: PageOrientation.LANDSCAPE,
            },
            // margin: {
            //   top: 1800,
            //   bottom: 1800,
            //   left: 2160,
            //   right: 1440
            // }
          },
        },
        children: [
          new Table({
            width: {
              size: "100%",
              type: WidthType.PERCENTAGE,
            },

            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      text(
                        {
                          text: isViags ? "PHIẾU YÊU CẦU HOÀN VÉ" : "PHIẾU YÊU CẦU ĐẶT CHỖ VÀ XUẤT VÉ QUA EMAIL",
                          size: 28,
                          bold: true,
                        },
                        {
                          alignment: AlignmentType.CENTER,
                        },
                      ),
                    ],
                    // width: {
                    //   size: "100%",
                    //   type: WidthType.PERCENTAGE,
                    // },
                    columnSpan: 14,
                    verticalAlign: VerticalAlign.BOTTOM,
                    margins: { bottom: 50 },
                  }),
                ],
                height: {
                  value: 1200,
                  rule: HeightRule.EXACT,
                },
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      text(
                        { text: `Ngày mua vé: Ngày  tháng  năm ${date.getFullYear()}`, size: 28 },
                        {
                          alignment: AlignmentType.LEFT,
                        },
                      ),
                    ],
                    margins: { left: 50 },
                    // width: {
                    //   size: 5000,
                    //   type: WidthType.DXA,
                    // },
                    columnSpan: 14,
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                ],
                height: {
                  value: 700,
                  rule: HeightRule.EXACT,
                },
              }),

              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      text(
                        { text: `Phiếu số:    /${date.getFullYear()}`, size: 28 },
                        {
                          alignment: AlignmentType.LEFT,
                        },
                      ),
                    ],
                    // width: {
                    //   size: "100%",
                    //   type: WidthType.PERCENTAGE,
                    // },
                    margins: { left: 50 },
                    columnSpan: 2,
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                  new TableCell({
                    children: [
                      text(
                        { text: "Nơi nhận: Công ty TNHH thương mại và du lịch Thành Việt", size: 28 },
                        {
                          alignment: AlignmentType.LEFT,
                        },
                      ),
                    ],
                    // width: {
                    //   size: "100%%",
                    //   type: WidthType.PERCENTAGE,
                    // },
                    margins: { left: 50 },
                    columnSpan: 12,
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                ],
                height: {
                  value: 700,
                  rule: HeightRule.EXACT,
                },
              }),

              new TableRow({
                children: !isViags
                  ? [
                      new TableCell({
                        children: [
                          text(
                            { text: "Số TT", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                            },
                          ),
                        ],
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: "Họ tên", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: "Chức vụ", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        width: {
                          size: "20%",
                          type: WidthType.PERCENTAGE,
                        },
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: "Đơn vị", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        width: {
                          size: "15%",
                          type: WidthType.PERCENTAGE,
                        },
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: "Hành trình", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: "Hạng ghế", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: "Ưu tiên", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: !isViags ? "Mã đặt chỗ" : "Số vé", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                    ]
                  : [
                      new TableCell({
                        children: [
                          text(
                            { text: "Số TT", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                            },
                          ),
                        ],
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: "Họ tên", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: "Chức vụ", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: "Đơn vị", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: "Hành trình", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        width: {
                          size: 2000,
                          type: WidthType.DXA,
                        },
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new TableCell({
                        children: [
                          text(
                            { text: "Hạng ghế", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),

                      new TableCell({
                        children: [
                          text(
                            { text: !isViags ? "Mã đặt chỗ" : "Số vé", size: 28, bold: true },
                            {
                              alignment: AlignmentType.CENTER,
                              indent: { left: 100 },
                            },
                          ),
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                    ],
              }),

              ...item.map((e: any, index: number) => {
                return new TableRow({
                  children: !isViags
                    ? [
                        new TableCell({
                          children: [
                            text(
                              { text: index + 1 + "", size: 28 },
                              {
                                alignment: AlignmentType.CENTER,
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              { text: e.PassportForPerson, size: 28 },
                              {
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              { text: e.Position, size: 28 },
                              {
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          width: {
                            size: "20%",
                            type: WidthType.PERCENTAGE,
                          },
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              { text: e.Unit, size: 28 },
                              {
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          width: {
                            size: "15%",
                            type: WidthType.PERCENTAGE,
                          },
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              // { text: "Hành trình", size: 28 },
                              e.Trip.map((trip: any, index: number) => {
                                return {
                                  text: `${trip.from} - ${trip.to}`,
                                  size: 26,
                                  bold: true,
                                  break: index ? 1 : 0,
                                };
                              }),
                              {
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              { text: e.Class ? e.Class : "", size: 28 },
                              {
                                alignment: AlignmentType.CENTER,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              { text: "", size: 28 },
                              {
                                alignment: AlignmentType.CENTER,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              { text: "", size: 28 },
                              {
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                      ]
                    : [
                        new TableCell({
                          children: [
                            text(
                              { text: index + 1 + "", size: 28 },
                              {
                                alignment: AlignmentType.CENTER,
                              },
                            ),
                          ],
                          width: {
                            size: "5%",
                            type: WidthType.PERCENTAGE,
                          },
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              { text: e.PassportForPerson, size: 28 },
                              {
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              { text: e.Position, size: 28 },
                              {
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              { text: e.Unit, size: 28 },
                              {
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              // { text: "Hành trình", size: 28 },
                              e.Trip.map((trip: any, index: number) => {
                                return { text: `${trip.from} - ${trip.to}`, size: 28, break: index ? 1 : 0 };
                              }),
                              {
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              { text: e.Class ? e.Class : "", size: 28 },
                              {
                                alignment: AlignmentType.CENTER,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                        new TableCell({
                          children: [
                            text(
                              { text: `${isViags ? e.TickNumber || "" : ""}`, size: 28 },
                              {
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                              },
                            ),
                          ],
                          verticalAlign: VerticalAlign.CENTER,
                        }),
                      ],
                });
              }),

              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      text(
                        { text: "", size: 28 },
                        {
                          alignment: AlignmentType.RIGHT,
                        },
                      ),
                    ],
                    margins: { right: 100 },
                    columnSpan: 4,
                    borders: {
                      top: {
                        style: BorderStyle.NONE,
                        color: "ffffff",
                      },
                      bottom: {
                        style: BorderStyle.NONE,
                      },
                      right: {
                        style: BorderStyle.NONE,
                        color: "ffffff",
                      },
                    },
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                  new TableCell({
                    children: [
                      text(
                        [
                          {
                            text:
                              idHead.split("|")[0] === "hieptd@viags.vn" ? "CHÁNH VĂN PHÒNG CÔNG TY" : "NGƯỜI DUYỆT",
                            size: 28,
                            bold: true,
                          },
                          {
                            text: idHead.split("|")[0] === "hieptd@viags.vn" ? idHead.split("|")[1] : approverName,
                            size: 28,
                            break: 5,
                            bold: true,
                          },
                        ],
                        {
                          alignment: AlignmentType.CENTER,
                        },
                      ),
                    ],
                    margins: { right: 100, top: 50 },
                    borders: {
                      left: {
                        style: BorderStyle.NONE,
                        color: "ffffff",
                      },
                    },
                    columnSpan: 4,
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                ],
                height: {
                  value: 2222,
                  rule: HeightRule.EXACT,
                },
              }),
            ],
          }),

          breakLine(1),
        ],
      },
    ],
  });
};
export default getExportTicketForm;
